/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import people from '../../../../../../assets/student-training/pypi/section3-img3.png';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import { HCG_ICONS } from './iconMap';
import eliIllustration from '../../../../../../assets/student-training/pypi/section3-img4.png';
import NumberedStepsIllustration from '../../components/NumberedStepsIllustration';
import stepIllustration from '../../../../../../assets/student-training/pypi/step-bg.png';
import stepBg1 from '../../../../../../assets/student-training/pyde/step-bg1.png';
import stepBg2 from '../../../../../../assets/student-training/pyde/step-bg2.png';
import stepBg3 from '../../../../../../assets/student-training/pyde/step-bg3.png';
import stepBg4 from '../../../../../../assets/student-training/pyde/step-bg4.png';
import stepBg5 from '../../../../../../assets/student-training/pyde/step-bg5.png';

const STEP_CARD_BACKGROUNDS = [stepBg1, stepBg2, stepBg3, stepBg4, stepBg5];

interface Settings {
  paragraphs: any[];
}

interface ISection2Props {
  settings: Settings;
}

const Section3: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = useState({ quiz: false });

  console.log(paragraphsSettings, 'paragraphsSettings');
  const highlightedCardsGridItems = useMemo(() => {
    return paragraphsSettings?.items?.map((item: any, index: number) => ({
      ...item,
      icon: HCG_ICONS[index](false),
    }));
  }, [paragraphsSettings]);
    const handleComplete = React.useCallback(() => {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'student-training-pypi-section3-1'
      );
    }, [updateComponentState, p_course, p_topic, ID]);
  

  return (
    <div className="topic-section-3">
      <HighlightedCardsGrid
        mainTitle={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.subTitle}
        description={paragraphsSettings?.description}
        items={highlightedCardsGridItems}
      />
      <div style={{ margin: '5rem 0 8rem 0' }}>
        <ExpandableListIllustration
          subTitle={paragraphsSettings?.section2Title}
          description={paragraphsSettings?.section2desc}
          illustration={<img src={eliIllustration} alt="" />}
          items={paragraphsSettings?.maliciousFileItems}
        id="student-training-pypi-section3-1"
        onComplete={handleComplete}
        />
      </div>
      <div style={{ margin: '10rem 0 5rem 0' }}>
        <NumberedStepsIllustration
          mainTitle={paragraphsSettings?.section1MainTitle}
          description={paragraphsSettings?.section1Desc}
          illustration={<img src={stepIllustration} alt="" />}
          cardBackgrounds={STEP_CARD_BACKGROUNDS}
          items={paragraphsSettings?.section1Items}
        />
      </div>
      <div id="student-training-psa-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle ?? ''}
          description={paragraphsSettings?.quiz?.description ?? ''}
          question={paragraphsSettings?.quiz?.question ?? ''}
          options={paragraphsSettings?.quiz?.options ?? []}
          quizImg={people}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'student-training-psa-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section3;
